<template>
    <div class="w-100 d-flex justify-content-between align-items-center property-listing-header">
        <div
                class="property-listing-title"
                v-html="title"
        />
        <switcher
                class="mx-2"
                :options="options"
                @switcher:item-selected="handleItemSelected"
                :default-option-value="filter.orderBy ? filter.orderBy.value : ''"
                :auto-set-current-option="false"
        >
          <template slot="switcher-list">
              <VueCustomScrollbar
                  :settings="{wheelPropagation:false}"
                  class="scroll-area"
              >
                  <b-dropdown-item
                      v-for="(option, key) in options"
                      :key="`switcher-option-${key}`"
                      @click="handleItemSelected(option)"
                  >
                      <b-row
                          :class="{active: filter.orderBy.value === option.value}"
                      >
                          <b-col>
                              {{ option.text }}
                          </b-col>
                      </b-row>
                  </b-dropdown-item>
              </VueCustomScrollbar>
          </template>
        </switcher>
    </div>
</template>

<script>
    import './PropertyListingHeader.scss';
    import isEmpty from 'lodash/isEmpty';
    import Switcher from '@milestoneslabs/milestones-ui-kit/src/components/Switcher/Switcher';
    import {SORT_FIELDS} from '../../../../../helpers/filterOptions';
    import {proxyFilter} from "../../../../classes/Filter";
    import {formatNumber} from '../../../../../helpers/functions';
    import VueCustomScrollbar from 'vue-custom-scrollbar';
    import {TABS} from "../../../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader";

    export default {
        name: 'PropertyListingHeader',

        components: {
            Switcher,
            VueCustomScrollbar,
        },

        props: {
            total: {
                type: Number,
                required: true,
            },
            address: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                options: SORT_FIELDS,
                filter: proxyFilter,
            };
        },

        computed: {
            isFavoritesTab() {
                return String(this.$route.query.tab) === String(TABS.FAVORITE);
            },
            title() {
                let suffix = this.isFavoritesTab ? 'Favorite' : 'Home';
                let title =
                    `<h2 class="mb-0 d-inline-flex">
                        ${this.formatNumber(this.total, false)} ${suffix}${(this.total === 1) ? '' : 's'}
                    </h2>`;

                if (!isEmpty(this.address)) {
                    title = `${title}<span class="near"> near ${this.address}</span>`;
                }

                return title;
            }
        },

        methods: {
            formatNumber,

            handleItemSelected(selectedOption) {
                this.filter.orderBy = selectedOption;
            },
        },
    };
</script>
